/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as StepUpRouteImport } from './routes/step-up'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PasswordDecisionRouteImport } from './routes/password-decision'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as EnrollMfaRouteImport } from './routes/enroll-mfa'
import { Route as DuplicateAccountRouteImport } from './routes/duplicate-account'
import { Route as R2faRouteImport } from './routes/2fa'
import { Route as IndexRouteImport } from './routes/index'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const StepUpRoute = StepUpRouteImport.update({
  id: '/step-up',
  path: '/step-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordDecisionRoute = PasswordDecisionRouteImport.update({
  id: '/password-decision',
  path: '/password-decision',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const EnrollMfaRoute = EnrollMfaRouteImport.update({
  id: '/enroll-mfa',
  path: '/enroll-mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const DuplicateAccountRoute = DuplicateAccountRouteImport.update({
  id: '/duplicate-account',
  path: '/duplicate-account',
  getParentRoute: () => rootRouteImport,
} as any)
const R2faRoute = R2faRouteImport.update({
  id: '/2fa',
  path: '/2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/2fa': typeof R2faRoute
  '/duplicate-account': typeof DuplicateAccountRoute
  '/enroll-mfa': typeof EnrollMfaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/password-decision': typeof PasswordDecisionRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/sessions': typeof SessionsRoute
  '/signup': typeof SignupRoute
  '/step-up': typeof StepUpRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/2fa': typeof R2faRoute
  '/duplicate-account': typeof DuplicateAccountRoute
  '/enroll-mfa': typeof EnrollMfaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/password-decision': typeof PasswordDecisionRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/sessions': typeof SessionsRoute
  '/signup': typeof SignupRoute
  '/step-up': typeof StepUpRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/2fa': typeof R2faRoute
  '/duplicate-account': typeof DuplicateAccountRoute
  '/enroll-mfa': typeof EnrollMfaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/password-decision': typeof PasswordDecisionRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/sessions': typeof SessionsRoute
  '/signup': typeof SignupRoute
  '/step-up': typeof StepUpRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/2fa'
    | '/duplicate-account'
    | '/enroll-mfa'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/password-decision'
    | '/reset-password'
    | '/security'
    | '/sessions'
    | '/signup'
    | '/step-up'
    | '/verify-email'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/2fa'
    | '/duplicate-account'
    | '/enroll-mfa'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/password-decision'
    | '/reset-password'
    | '/security'
    | '/sessions'
    | '/signup'
    | '/step-up'
    | '/verify-email'
  id:
    | '__root__'
    | '/'
    | '/2fa'
    | '/duplicate-account'
    | '/enroll-mfa'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/password-decision'
    | '/reset-password'
    | '/security'
    | '/sessions'
    | '/signup'
    | '/step-up'
    | '/verify-email'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R2faRoute: typeof R2faRoute
  DuplicateAccountRoute: typeof DuplicateAccountRoute
  EnrollMfaRoute: typeof EnrollMfaRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  PasswordDecisionRoute: typeof PasswordDecisionRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SecurityRoute: typeof SecurityRoute
  SessionsRoute: typeof SessionsRoute
  SignupRoute: typeof SignupRoute
  StepUpRoute: typeof StepUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/step-up': {
      id: '/step-up'
      path: '/step-up'
      fullPath: '/step-up'
      preLoaderRoute: typeof StepUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-decision': {
      id: '/password-decision'
      path: '/password-decision'
      fullPath: '/password-decision'
      preLoaderRoute: typeof PasswordDecisionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enroll-mfa': {
      id: '/enroll-mfa'
      path: '/enroll-mfa'
      fullPath: '/enroll-mfa'
      preLoaderRoute: typeof EnrollMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/duplicate-account': {
      id: '/duplicate-account'
      path: '/duplicate-account'
      fullPath: '/duplicate-account'
      preLoaderRoute: typeof DuplicateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/2fa': {
      id: '/2fa'
      path: '/2fa'
      fullPath: '/2fa'
      preLoaderRoute: typeof R2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R2faRoute: R2faRoute,
  DuplicateAccountRoute: DuplicateAccountRoute,
  EnrollMfaRoute: EnrollMfaRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  PasswordDecisionRoute: PasswordDecisionRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SecurityRoute: SecurityRoute,
  SessionsRoute: SessionsRoute,
  SignupRoute: SignupRoute,
  StepUpRoute: StepUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
